<template>
  <b-container id="body-container" style="padding: 0px" fluid>
    <b-row class="justify-content-center mb-5">
      <b-col cols="10">

        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="10" md="8">
            <span>
              <h4 class="text-blackish title-body">React before you lose accounts</h4>
            </span>
          </b-col>
          <b-col cols="2" md="3">
            <div class="color-design"></div>
          </b-col>
        </b-row>

        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="10" md="8">
            <span>
              <h5>Get alerted when your client champion leaves a key account.</h5>
              <h5>Find new contacts to maintain your relationship with the key account. (Meanwhile expand wherever your client champion started a new job) </h5>
            </span>
          </b-col>
        </b-row>



        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="10" md="8">
            <span>
              <h4 class="text-blackish title-body">Expand your current accounts</h4>
            </span>
          </b-col>
          <b-col cols="2" md="3">
            <div class="color-design"></div>
          </b-col>
        </b-row>

        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="10" md="8">
            <h5>Tracking your total addressable market, get alerted when targets are hired, promoted, or start an additional position.</h5>
            <h5>This is the perfect time to ask how you can help with their additional responsibilities</h5>
          </b-col>
        </b-row>




        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="10" md="8">
            <span>
              <h4 class="text-blackish title-body">Keep your CRM reliable</h4>
            </span>
          </b-col>
          <b-col cols="2" md="3">
            <div class="color-design"></div>
          </b-col>
        </b-row>

        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="10" md="8">
            <span>
              <h5>5% of your CRM changes each month, because 5% of the market starts a new job each month. </h5>
              <h5>Update the right 5% and re-engage by congratulating them on their promotion, funding, etc...</h5>
              <h5>Timely, personalized conversations build trust that leads to sales. </h5>
              <h5>Include 3+ accurate personalized details in your outreach for maximum success. </h5>
            </span>
          </b-col>
        </b-row>

      </b-col>
    </b-row>


    <b-row id="launch-today-container" class="justify-content-center live-now">
      <b-col md="10">
        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="12" md="12">
            <span>
              <h2 class="text-blackish cta-title" style="text-align:center; color:white"><span style="color:deepskyblue">Regularly updating your CRM</span> helps <span style="color:deepskyblue">sales</span>, <span style="color:deepskyblue">marketing</span>, and <span style="color:deepskyblue">customer success</span> trust the <span style="color:deepskyblue">quality</span> of their <span style="color:deepskyblue">personalized outreach</span> & nail timing.</h2>
            </span>
          </b-col>
        </b-row>

        <b-row class="">
        <b-col md="12" cols="12" class="buttons-close" >
          <span
            class="d-flex justify-content-center"
          >
            <b-button
                class="free-trial-button"
                @click.prevent="scrollFix('#filters')"
              >Request Demo</b-button>
          </span>

          <!--
          <a
            href="https://www.launchgravity.com/masters-of-marketing/#upcoming"
          >
            <b-button class="button-white-transparen"><b>Check our events</b></b-button>
          </a>
          -->
        </b-col>
      </b-row>
      </b-col>
    </b-row>

   <b-row class="justify-content-center mb-5">
    <b-col cols="12" id="filters">

      <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="12" md="12">
            <div class=" mx-auto">
              <div class="calendly-inline-widget" data-url="https://calendly.com/rosse/clean-your-dirty-crm?text_color=193b56&primary_color=1765d8"></div>
            </div>
          </b-col>
        </b-row>
    </b-col>
   </b-row>

  </b-container>
</template>

<style scoped lang="sass">
@import @/sass/screens/masters-of-marketing/body.sass
@import @/sass/_components/main-card.sass
@import @/sass/screens/home/header.sass

</style>

<script>
// components
// import MainCard from '@/components/mainCardHome'
// import ourFleet from '@/components/ourFleetCard'
// import ourFleetOG from '@/components/ourFleetCardOriginal'
// import HostCard from '@/components/hostCard'
import VueScrollTo from 'vue-scrollto';

// data
// import { guests, yourHosts } from '@/data/masters-of-marketing.js'

export default {
  name: 'Body',
  components: {
    //MainCard,
    // ourFleet,
    //ourFleetOG,
    // HostCard
  },
  data: function() {
    return {
      timer: null,
      currentDate: null,

    }
  },
  computed: {
  },
  mounted() {
    let externalScript = document.createElement('script')
    externalScript.setAttribute('src', 'https://assets.calendly.com/assets/external/widget.js')
    document.head.appendChild(externalScript)
  },
  created() {
  },
  methods: {
    scrollFix: function(hash) {
      console.log('Scroll To')
      VueScrollTo.scrollTo(hash, 3000)
    },

  },
}
</script>
